<tec-modal
    [isVisible]="isVisible"
    [title]="getTitle() | translate"
    (closeEvent)="closeModal()"
>
    <div class="modal__body grid" style="justify-items: center; gap: 1rem">
        <p [innerHTML]="getInstructions()"></p>
        @if (instructionsPhotoUrl) {
            <img
                [src]="instructionsPhotoUrl"
                [alt]="'DOCUMENTS.ACCESSIBILITY.INSTRUCTIONS_PHOTO' | translate"
                loading="lazy"
            />
        }
    </div>
</tec-modal>
